import { CategoryLibrary } from "@/components/admin/CategoryLibrary";

export function SettingsCategoriesPage() {
  return <CategoryLibrary />;
}
